import { Timeline, TimelineItem, timelineItemClasses, TimelineSeparator, TimelineConnector, TimelineDot, TimelineContent, DateRangePicker } from "@mui/lab";
import TimelineOppositeContent, {
    timelineOppositeContentClasses,
} from '@mui/lab/TimelineOppositeContent';
import { LocalizationProvider, DateTimePicker} from "@mui/x-date-pickers";
import { Box, Button, Icon, MenuItem, Select, Typography } from "@mui/material";
import { LogItem, NLCInfo, TableInfo } from "../../data/interfaces/sharedmodels";
import magneticService from "../../data/api/magnetic.service";
import { useEffect, useState } from "react";
import itsoService from "../../data/api/itso.service";
import commonService from "../../data/api/common.service";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { Dayjs } from "dayjs";

export default function Logs({ parent }: { parent: string }) {
    const [nlcs, setNlcs] = useState<NLCInfo[]>([]);
    const [selectedNlc, setSelectedNlc] = useState<string>("-99");
    const [tables, setTables] = useState<TableInfo[]>([]);
    const [selectedTable, setSelectedTable] = useState<string>("-99");
    const [logs, setLogs] = useState<LogItem[]>([]);
    const [isHidden, setIsHidden] = useState<boolean>(false);
    const [pageCounter, setPageCounter] = useState<number>(0);
    const [isfilterChanged,setIsFilterChanged]=useState(false);
    const [fromDate,setFromDate]=useState<Date|null>(null);
    const [toDate,setToDate]=useState(null);
    useEffect(() => {
        loadData();

    }, []);
    useEffect(() => {
        loadLogs();
    }, [pageCounter]);

    useEffect(()=>{
        setIsFilterChanged(true);
        
    },[selectedNlc,selectedTable,fromDate,toDate]);

    

    useEffect(()=>{
        if(isfilterChanged){
            if(pageCounter==0)
                loadLogs();
            else
                setPageCounter(0);
        }
    },[isfilterChanged])


    const loadLogs=()=>{
        if (parent == "magnetic") {
            magneticService.getLogs(pageCounter,selectedNlc,selectedTable,fromDate,toDate).then((response) => {
                if(isfilterChanged)
                    setLogs(response.data);
                else
                    setLogs([...logs].concat(response.data));
                setIsHidden(response.data && response.data.length < 10);
                setIsFilterChanged(false);
            });
        }
        else {
            itsoService.getLogs(pageCounter,selectedNlc,selectedTable,fromDate,toDate).then((response) => {
                if(isfilterChanged)
                    setLogs(response.data);
                else
                    setLogs([...logs].concat(response.data));
                setIsHidden(response.data && response.data.length < 10);
                setIsFilterChanged(false);
            })
        }
    }
    const loadData = () => {
        if (parent == "magnetic") {

            magneticService.getdatatables().then((response)=>{
                setTables(response.data);
            })
        }
        else {
            itsoService.getdatatables().then((response)=>{
                setTables(response.data);
            })
        }
        commonService.getnlcs().then((response) => {
            setNlcs(response.data);
        });
    }

    const onLoadMore = () => {
        setPageCounter(pageCounter + 1);

    }


    return (
        <Box sx={{ bgcolor: '#fff' }}>
            <Box sx={{ p: 2, display: 'flex',justifyContent:'center' }}>
                <Select
                    size="small"
                    sx={{ width: '250px',mr:1 }}
                    value={selectedNlc}
                    onChange={(event) => setSelectedNlc(event.target.value)}>
                        <MenuItem key={-99} value={"-99"}>Select Station</MenuItem>
                    {nlcs.map((item) => {
                        return (
                            <MenuItem key={item.Id} value={item.Id}>{item.StationName}</MenuItem>
                        )
                    })}
                </Select>
                <Select
                    size="small"
                    sx={{ width: '250px',mr:1  }}
                    value={selectedTable}
                    onChange={(event) => setSelectedTable(event.target.value)}>
                        <MenuItem key={-99} value={"-99"}>Select Table</MenuItem>
                    {tables.map((item) => {
                        return (
                            <MenuItem key={item.Id} value={item.Id}>{item.Description}</MenuItem>
                        )
                    })}
                </Select>
                <LocalizationProvider dateAdapter={AdapterDayjs}>
                    <DateTimePicker value={fromDate} format="DD-MM-YYYY hh:mm A"  sx={{mr:1}} label="Start Date" disableFuture onAccept={(value) => setFromDate(value)}/>
                    <DateTimePicker value={toDate} format="DD-MM-YYYY hh:mm A" label="To Date" disableFuture  onAccept={(value) => setToDate(value)}/>
                </LocalizationProvider>
            </Box>
            <Timeline
                sx={{
                    [`& .${timelineOppositeContentClasses.root}`]: {
                        flex: 0.3
                    },
                }}
            >
                {
                    logs.map((logitem) => {
                        return (

                            <TimelineItem key={logitem.Id}>
                                <TimelineOppositeContent
                                    color="text.secondary" sx={{ display: 'inline-grid' }}
                                >
                                    <Typography variant="body1" component="span">
                                        {logitem.DateCreated}
                                    </Typography>
                                    <Typography>{logitem.CreatedUser}</Typography>

                                </TimelineOppositeContent>
                                <TimelineSeparator>
                                    <TimelineConnector />
                                    <TimelineDot color="primary">
                                        <Icon>{logitem.Icon}</Icon>
                                    </TimelineDot>
                                    <TimelineConnector />
                                </TimelineSeparator>
                                <TimelineContent sx={{ display: 'inline-grid' }}>
                                    <Typography variant="body1" component="span">
                                        {logitem.Type + (logitem.Remarks ? " - " + logitem.Remarks : "")}
                                    </Typography>
                                    <Typography>{logitem.Description}</Typography>
                                </TimelineContent>
                            </TimelineItem>

                        );
                    })

                }

            </Timeline>
            {isHidden ? null : <Button onClick={onLoadMore} sx={{ ml: 38.75, mb: 3 }} variant="outlined">Load More</Button>}
        </Box>
    );
}